import React, { useState, useEffect } from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  Grid,
  Typography
} from '@material-ui/core';
import { i18n } from '../App';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { makeStyles } from '@material-ui/core/styles';
import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';
import config from '../config';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(4),
    outline: 'none',
    display: 'flex',
    position: 'relative'
  },
  text: {
    flex: '1 1 auto',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingRight: theme.spacing(2)
  },
  swiperContainer: {
    textAlign: 'right',
    width: '100%'
  },
  image: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // maxHeight: 'calc(100vh - 200px)',
    display: 'block',
    width: '100%',
    height: 400
  },
  dialogActions: {
    paddingBottom: theme.spacing(4),
    paddingRight: theme.spacing(6)
  }
}));

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const CommitmentModal = () => {
  // console.log('DRAW MODAL');
  const [globalState, globalDispatch] = useCoolfoodContext();

  const [commit, setCommit] = useState(globalState.selectedCommitments || []);

  const createMarkup = txt => ({ __html: txt });

  useEffect(() => {
    // Get commit from state and set is as local state
    const cmt = globalState.happening.commitments.filter(
      c => c.id === globalState.commitmentModal
    );
    setCommit(cmt[0]);
  }, [globalState.commitmentModal, globalState.happening.commitments]);

  const classes = useStyles();

  function selectCommitment(id) {
    // Do not add commitment twice
    const exists = globalState.selectedCommitments.find(sid => sid === id);
    if (!exists) {
      globalDispatch({ type: actions.SELECT_COMMITMENT, id: id });
    }
    globalDispatch({ type: actions.SHOW_MODAL, id: null });
  }

  // return <div className={classes.root}>{JSON.stringify(commit)}</div>;
  return (
    <>
      <DialogContent>
        <Grid container className={classes.root}>
          <Grid item className={classes.text} sm={12} md={6}>
            <Typography variant="h5">{commit.name}</Typography>
            <div dangerouslySetInnerHTML={createMarkup(commit.description)} />
          </Grid>
          <Grid item className={classes.swiperContainer} sm={12} md={6}>
            {commit.images && (
              <AutoPlaySwipeableViews enableMouseEvents interval={4000}>
                {commit.images.map(img => (
                  <div
                    className={classes.image}
                    key={img.id}
                    style={{
                      backgroundImage: `url(${config.siteUrl}${img.url})`,
                      width: 'auto'
                    }}
                    alt={img.name}
                  />
                ))}
              </AutoPlaySwipeableViews>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          className={classes.button}
          onClick={() => globalDispatch({ type: actions.SHOW_MODAL, id: null })}
          color="primary"
        >
          {i18n._('Fermer')}
        </Button>
        {globalState.coolfooder.commitsAlreadyTaken.indexOf(commit.id) ===
          -1 && !commit.is_selected && (
          <Button
            className={classes.button}
            onClick={() => selectCommitment(commit.id)}
            color="primary"
            variant="contained"
          >
            {i18n._('Choisir cet engagement')}
          </Button>
        )}
      </DialogActions>
    </>
  );
};

export default CommitmentModal;
